import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClosedLeadTasks = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 324 200",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("path", {
		id: "a",
		d: "M0 0h400v440H0z"
	}), /* @__PURE__ */ _jsx("filter", {
		x: "-1.4%",
		y: "-5.4%",
		width: "102.7%",
		height: "110.7%",
		filterUnits: "objectBoundingBox",
		id: "c",
		children: /* @__PURE__ */ _jsx("feGaussianBlur", {
			stdDeviation: 1,
			in: "SourceGraphic"
		})
	})] }), /* @__PURE__ */ _jsxs("g", {
		transform: "translate(-76 -120)",
		fill: "none",
		fillRule: "evenodd",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "b",
			fill: "#fff",
			children: /* @__PURE__ */ _jsx("use", { xlinkHref: "#a" })
		}), /* @__PURE__ */ _jsx("g", {
			mask: "url(#b)",
			children: /* @__PURE__ */ _jsxs("g", {
				transform: "translate(78 120)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						fill: "#483D9F",
						filter: "url(#c)",
						y: 92,
						width: 220,
						height: 56,
						rx: 4
					}),
					/* @__PURE__ */ _jsx("rect", {
						fill: "#FFF",
						width: 220,
						height: 56,
						rx: 4,
						transform: "translate(248)",
						opacity: .4
					}),
					/* @__PURE__ */ _jsxs("g", {
						transform: "translate(248 72)",
						opacity: .4,
						fill: "#FFF",
						children: [/* @__PURE__ */ _jsx("rect", {
							width: 220,
							height: 56,
							rx: 4
						}), /* @__PURE__ */ _jsx("rect", {
							x: 20,
							y: 18,
							width: 20,
							height: 20,
							rx: 1.6
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						transform: "translate(248 144)",
						opacity: .4,
						fill: "#FFF",
						children: [/* @__PURE__ */ _jsx("rect", {
							width: 220,
							height: 56,
							rx: 4
						}), /* @__PURE__ */ _jsx("rect", {
							x: 20,
							y: 18,
							width: 20,
							height: 20,
							rx: 1.6
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						transform: "translate(12)",
						children: [/* @__PURE__ */ _jsx("rect", {
							fill: "#FFF",
							opacity: .4,
							width: 220,
							height: 56,
							rx: 4
						}), /* @__PURE__ */ _jsxs("g", {
							fill: "#C2BDE7",
							fillRule: "nonzero",
							children: [/* @__PURE__ */ _jsx("path", { d: "M110 12c-8.81 0-16 7.19-16 16 0 8.81 7.19 16 16 16 8.81 0 16-7.19 16-16 0-8.81-7.19-16-16-16zm0 28.95c-7.147 0-12.95-5.803-12.95-12.95 0-7.147 5.803-12.95 12.95-12.95 7.147 0 12.95 5.803 12.95 12.95 0 7.147-5.803 12.95-12.95 12.95z" }), /* @__PURE__ */ _jsx("path", { d: "M115.376 30.283l4.437-5.035-6.485-1.28-3.221-5.781-3.435 5.781-6.485 1.28 4.437 5.035.021-.043v.043l-.661 6.677L110 34.208l6.016 2.752-.661-6.656z" })]
						})]
					}),
					/* @__PURE__ */ _jsxs("g", {
						transform: "translate(12 72)",
						children: [/* @__PURE__ */ _jsx("rect", {
							fill: "#FFF",
							width: 220,
							height: 56,
							rx: 4
						}), /* @__PURE__ */ _jsxs("g", {
							transform: "translate(20 18)",
							children: [/* @__PURE__ */ _jsx("rect", {
								opacity: .4,
								width: 20,
								height: 20,
								rx: 1.667
							}), /* @__PURE__ */ _jsx("path", {
								fill: "#5649BE",
								fillRule: "nonzero",
								d: "M16.134 3.333l-1.037 1.12-7.225 7.801-2.168-2.206L4.636 8.96 2.5 11.135l1.068 1.087 3.267 3.325 1.1 1.12 1.068-1.151 8.293-8.953 1.037-1.12z"
							})]
						})]
					})
				]
			})
		})]
	})]
});
export default SvgClosedLeadTasks;
